import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as actions from './store/actions/chat-history';

import withErrorHandler from '../../hoc/with-error-handler';
import axios from '../../shared/axios';

import ChatMessagesArea from './components/chat-message-area';

import { AppDispatch, RootState } from '../../store';

export type SupportChatComponentProps = {
  userType: number;
  trackingCompanyId: string;
};

const SupportChatComponent = ({ userType, trackingCompanyId }: SupportChatComponentProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const chats = useSelector((state: RootState) => state.supportChat.chats);

  //to change logic
  useEffect(() => {
    fetchChats();
  }, []);
  //to change logic
  const fetchChats = () => {
    dispatch(actions.getChatByInsuredId({ insuredId: trackingCompanyId }));
  };

  return (
    <>
      <ChatMessagesArea userType={userType} selectedChat={chats} />
    </>
  );
};

export default withErrorHandler(SupportChatComponent, axios);
